import { ReactNode } from "react";
import { tv } from "tailwind-variants";

const pill = tv({
  base: "bg-shale-800 rounded-lg px-5 py-2.5 flex items-center gap-2.5 text-sm text-shale-200 w-fit",
});

interface PillProps {
  className?: string;
  children?: ReactNode;
}

export function Pill({ className, children }: PillProps): JSX.Element {
  return <div className={pill({ className })}>{children}</div>;
}

Pill.pill = pill;
